const SUGGEST_AUTH_TITLES = {
  titleForNewUser: "Please sign up using your email address to get more launches of Sales Estimator",
  titleForExistingUser: "Please sign in to your AMZScout account to get more launches of Sales Estimator",
};

export default SUGGEST_AUTH_TITLES